var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMergeType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20934_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7001 19.7009C18.0901 19.3109 18.0901 18.6809 17.7001 18.2909L15.0001 15.5909L13.5901 17.0009L16.2901 19.7009C16.6801 20.0909 17.3201 20.0909 17.7001 19.7009ZM8.71006 8.00094H11.0001V13.5909L6.29006 18.2909C5.90006 18.6809 5.90006 19.3109 6.29006 19.7009C6.68006 20.0909 7.31006 20.0909 7.70006 19.7009L12.4101 15.0009C12.7901 14.6209 13.0001 14.1209 13.0001 13.5909V8.00094H15.2901C15.7401 8.00094 15.9601 7.46094 15.6401 7.15094L12.3501 3.86094C12.1501 3.66094 11.8401 3.66094 11.6401 3.86094L8.35006 7.15094C8.04006 7.46094 8.26006 8.00094 8.71006 8.00094Z",
    fill: "#53646C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20934_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeType);
export default __webpack_public_path__ + "static/media/merge_type.6781a8afa39109a870044e271fb8023f.svg";
export { ForwardRef as ReactComponent };